import * as React from 'react'
import { Styled } from './styled'
import { DownloadsItem } from './item'

export const Downloads = ({ downloads }) => {
  return (
    <Styled.Downloads>
      {downloads.map(item => (
        <DownloadsItem item={item} />
      ))}
    </Styled.Downloads>
  )
}
